import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { Stack, Button, TextField, FormControl, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';


const EditNote = () => {
  const { id } = useParams(); // noteId
  const navigate = useNavigate();
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchSingleNote = async () => {
    try {
      const res = await postRequest(`private/singleNotes/${id}`);
      if (res?.status === 200) {
        setNote(res?.data?.note || '');
      } else {
        toast.error(res?.message || 'Failed to load note');
      }
    } catch (err) {
      toast.error('Something went wrong while fetching note');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!note.trim()) return toast.error('Note cannot be empty');
    
    setLoading(true);
    try {
      const res = await postRequest(`private/editNotes/${id}`, { note });
      if (res?.status === 200) {
        toast.success('Note updated successfully');
        navigate(-1); // Go back
      } else {
        toast.error(res?.message || 'Failed to update note');
      }
    } catch (err) {
      toast.error('Something went wrong while updating note');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchSingleNote();
  }, [id]);

  return (
    <div>
      <Typography variant="h5" mb={3}>Edit Note</Typography>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="editNote">
          <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
            <TextField
              label="Write Note Here"
              multiline
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormControl>
        </Form.Group>

        <Stack spacing={2} direction="row">
          <Button variant="outlined" color="inherit" type="button" onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update Note'}
          </Button>
        </Stack>
      </Form>
    </div>
  );
};

export default EditNote;
